import React from "react";
import {
  GraduationCap,
  Folder,
  Folders,
  UserIcon,
  TextAlignJustify,
  ListEnd,
} from "lucide-react";
import { TFunction } from "i18next";
import { NavigateFunction } from "react-router-dom";
import { CreateOption } from "@components/CreateOptionPickerCst/types";

export type CreatePickerKind = "catalog" | "users-groups";

export interface CreatePickerBuildContext {
  navigate: NavigateFunction;
  corporateId: string;
  t: TFunction;
}

export interface CreatePickerDefinition {
  /** Permesso (o uno tra i permessi) necessario per aprire il picker */
  permission: string | string[];
  titleKey: string;
  buildOptions: (ctx: CreatePickerBuildContext) => CreateOption[];
}

export const CREATE_PICKER_REGISTRY: Record<
  CreatePickerKind,
  CreatePickerDefinition
> = {
  catalog: {
    permission: "learning_catalogue.learning_object.write",
    titleKey: "catalog.title",
    buildOptions: ({ navigate, corporateId, t }) => [
      {
        key: "activity",
        icon: <GraduationCap size={32} />,
        title: t("catalog.options.activity.title"),
        description: t("catalog.options.activity.description"),
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/catalog/activities/add`,
          ),
      },
      {
        key: "course",
        icon: <Folder size={32} />,
        title: t("catalog.options.course.title"),
        description: t("catalog.options.course.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/courses/add`),
      },
      {
        key: "path",
        icon: <Folders size={32} />,
        title: t("catalog.options.path.title"),
        description: t("catalog.options.path.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/paths/add`),
      },
    ],
  },
  // TODO: i flussi di creazione utente/gruppo verranno collegati al wizard V2.
  // Per ora le opzioni puntano alle pagine Add esistenti.
  "users-groups": {
    permission: [
      "usermgmt.users.add",
      "usermgmt.corporates.static_groups.write",
      "usermgmt.corporates.dynamic_groups.write",
    ],
    titleKey: "users-groups.title",
    buildOptions: ({ navigate, corporateId, t }) => [
      {
        key: "user",
        icon: <UserIcon size={32} />,
        title: t("users-groups.options.user.title"),
        description: t("users-groups.options.user.description"),
        permission: "usermgmt.users.add",
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/users-groups/add`),
      },
      {
        key: "static-group",
        icon: <TextAlignJustify size={32} />,
        title: t("users-groups.options.staticGroup.title"),
        description: t("users-groups.options.staticGroup.description"),
        permission: "usermgmt.corporates.static_groups.write",
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/users-groups/groups/add`,
          ),
      },
      {
        key: "dynamic-group",
        icon: <ListEnd size={32} />,
        title: t("users-groups.options.dynamicGroup.title"),
        description: t("users-groups.options.dynamicGroup.description"),
        permission: "usermgmt.corporates.dynamic_groups.write",
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/users-groups/dynamic-groups/add`,
          ),
      },
    ],
  },
};
